module.exports = __webpack_public_path__ + "media/images/order/done_all-ed59af2ad68f85137443f5ae5a4e9bcd.jpg";